import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../components/PageLoader";
import { selectPaymentTransactionsListItems } from "../../../../../../redux/e-pay/payment-transactions/selector";
import { paymentTransactions } from "../../../../../../redux/e-pay/payment-transactions/action";

const ManagementPaymentTransactions = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const paymentTransactionsListData = useSelector(selectPaymentTransactionsListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'AccountNumber', headerName: 'Account Number', searchField: 'AccountNumber', sortable: true, filter: true, filterType: 'number' },
      { field: 'BankName', headerName: 'Bank Name', searchField: 'BankName', sortable: true, filter: true, filterType: 'text' },
      { field: 'Branch', headerName: 'Branch', searchField: 'Branch', sortable: true, filter: true, filterType: 'text' },
      { field: 'BalanceAmount', headerName: 'Balance Amount', isCurrencyValueFormat: true },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(paymentTransactions.delete({
      url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/payments/delete`,
      entity: 'paymentTransactions',
      jsonData:
      {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchPaymentTransactionsList();
    });
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Payment Transaction</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const fetchPaymentTransactionsList = () => {
    dispatch(paymentTransactions.list({
      url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/payments/list`,
      entity: 'paymentTransactions',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "CreatedOnUtc",
        "SortOrder": "desc",
      }
    }))
  }

  const handleReloadData = () => {
    fetchPaymentTransactionsList();
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "BankName",
        FieldText: "BankName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(paymentTransactions.list({
      url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/payments/list`,
      entity: 'paymentTransactions',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  useEffect(() => {
    createColumnDefs()
    fetchPaymentTransactionsList()
  }, [pageData, pageSize])

  return (
    <>
      {paymentTransactionsListData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} rowData={[]}
          setPageData={setPageData} setPageSize={setPageSize} paginationData={paymentTransactionsListData?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          additionButtons={additionButtons}
          // onEdit={handleEdit} onDelete={handleDelete} 
          headingName="Payment Transactions"
        />
      }
    </>
  );
};

export default ManagementPaymentTransactions;


